export default __webpack_public_path__ + "static/media/femaleicon.0f66c91c.png";